import React from 'react'
import { compact } from 'lodash'

import { Button, Heading, Link } from 'core'

import css from './style.scss'

const BACKGROUNDS = {
  white: css.backgroundWhite,
  navy: css.backgroundNavy,
  grey: css.backgroundGrey
}

/**
 * Optional spotlight above the events list. Kept small on purpose — it exists
 * to flag one major offering, not to become a second hero.
 */
const EventsPromoBanner = ({
  headline,
  body,
  cta_label: ctaLabel,
  cta_url: ctaUrl,
  image_url: imageUrl,
  background
}) => {
  if (!headline) return null

  return (
    <div className={compact([css.banner, BACKGROUNDS[background] || BACKGROUNDS.grey]).join(' ')}>
      {imageUrl && <img className={css.bannerImage} src={imageUrl} alt='' />}

      <div className={css.bannerBody}>
        <Heading size='h4' weight='semibold' noMargin>{headline}</Heading>
        {body && (
          <div className={css.bannerText} dangerouslySetInnerHTML={{ __html: body }} />
        )}
      </div>

      {ctaUrl && (
        <div className={css.bannerAction}>
          <Link to={ctaUrl}>
            <Button size='secondary' noMargin className={css.ctaButton}>{ctaLabel || 'Learn More'}</Button>
          </Link>
        </div>
      )}
    </div>
  )
}

EventsPromoBanner.propTypes = {
  headline: React.PropTypes.string,
  body: React.PropTypes.string,
  cta_label: React.PropTypes.string,
  cta_url: React.PropTypes.string,
  image_url: React.PropTypes.string,
  background: React.PropTypes.string
}

export default EventsPromoBanner
